import React, { createContext, useState } from "react";
import { Outlet } from "react-router-dom";

export const UserContext = createContext();

export const UserContextProvider = (props) => {
  const [data, setData] = useState([]);

  // useEffect(() => {
  //   const handleUserList = async () => {
  //     try {
  //       const response = await listUsers();
  //       setData(response.data.data.userData);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  //   handleUserList();

  //   return () => {};
  // }, []);

  return (
    <UserContext.Provider
      value={{
        contextData: [data, setData],
      }}
    >
      <Outlet />
    </UserContext.Provider>
  );
};
